<div class="toast-container position-fixed top-0 end-0 p-3">
  <div *ngFor="let t of toasts" class="toast fade show" [class.toast-clickable]="!!t.onClick" role="alert" aria-live="assertive" aria-atomic="true" (click)="open(t)">
    <div class="toast-header">
      <img src="./assets/images/ls-logo.png" class="rounded me-2 logo" alt="ls">
      <strong class="me-auto">{{t.header || 'Ledgersync'}}</strong>
      <small *ngIf="t.time" class="text-muted">{{t.time}}</small>
      <button (click)="close(t); $event.stopPropagation()" type="button" class="btn-close" aria-label="Close"></button>
    </div>
    <div class="toast-body">{{t.message}}</div>
  </div>
</div>
